/**
 * @desc 数据报表模块
 */
import { reportAxios, reportAxiosDirect } from '../httpInstance';
// 报表列表
export function reportList(payload) {
    return reportAxios({
        method: 'POST',
        url: 'reportList',
        data: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
// 删除报表详情记录
export function deleteReportForm(payload) {
    return reportAxios({
        method: 'POST',
        url: 'deleteReportForm',
        data: { reportFormId: payload },
    });
}
// 生成报表/重新生成报表
export function createReport(payload) {
    return reportAxios({
        method: 'POST',
        url: 'createReport',
        data: JSON.stringify(payload),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
// 首页数据概览
export function homeDataPreview(data) {
    return reportAxios({
        method: 'POST',
        url: 'homeDataPreview',
        data,
    });
}
// 报表配置详情
export function reportConfigDetail(reportFormId) {
    return reportAxios({
        method: 'POST',
        url: 'reportConfig',
        data: {
            reportFormId,
        },
    });
}
// 报表数据分页查询
export function reportDetail(data) {
    return reportAxios({
        method: 'POST',
        url: 'repostDataQuery',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
// 报表数据分页查询
export function roundListQuery(data) {
    return reportAxios({
        method: 'POST',
        url: 'roundListQuery',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
// 查询报表预览数据 - 仅车商维度
export function queryPreView(data) {
    return reportAxios({
        method: 'POST',
        url: 'queryPreView',
        data: JSON.stringify(data),
        headers: {
            'Content-Type': 'application/json',
        },
    });
}
// 导出
export const globalExport = (params) => {
    return reportAxiosDirect({
        url: 'reportExport',
        method: 'POST',
        responseType: 'blob',
        data: params,
    });
};
